<template>
    <div class="home">
        <modal-vue
            :activate="modalActive"
            @handle-modal-close="modalActive = false"
        >
            <p>Возможность войти в личный кабинет предоставляется после оплаты какого-либо тарифа и выдачи личного
                логина</p>
            <input v-model="userLogin" type="text" placeholder="Введите логин пользователя">
            <main-button @handle-click="login">Войти</main-button>
        </modal-vue>
        <promo-vue @handle-click="checkUserLogon"></promo-vue>
        <about-vue></about-vue>
        <rates-vue></rates-vue>
        <reviews-vue></reviews-vue>
        <main-contacts/>
    </div>
</template>

<script>
import PromoVue from '@/components/mainPage/PromoVue.vue';
import ModalVue from '@/components/modals/ModalVue.vue';
import AboutVue from "@/components/mainPage/AboutVue";
import RatesVue from "@/components/mainPage/RatesVue";
import ReviewsVue from "@/components/mainPage/ReviewsVue";
import MainContacts from "@/components/mainPage/MainContacts";

export default {
    components: {MainContacts, PromoVue, ModalVue, AboutVue, RatesVue, ReviewsVue},
    data() {
        return {
            modalActive: false,
            userLogin: ''
        }
    },
    methods: {
        login() {
            this.$store.dispatch('checkUserByLogin', this.userLogin)
                .then(() => this.$router.push('/menu'))
        },
        checkUserLogon() {
            if (localStorage.getItem('login')) {
                this.$store.dispatch('checkUserByLogin', localStorage.getItem('login'))
                    .then(() => this.$router.push('/menu'))
            } else {
                this.modalActive = true
            }
        }
    },
    created() {
        document.title = 'You Course'
    }
}
</script>

<style lang="scss">
.home {
    background: #fbf8f4;
    padding-bottom: 67px;
        & button.btn {
            margin-top: 0;
        }
}
</style>
